import React, { Component } from 'react';
import AsyncSelectMenu from '../SelectMenu/AsyncSelectMenu';

export const SELECT_IDENTIFIER = 'source';

export default class SelectSource extends Component {
  render() {
    const { meta } = this.props;
    const source = 'select-sources';
    return (
      <div>
        <AsyncSelectMenu
          url={'/' + source + '?'}
          source={source}
          {...this.props}
          // autoFilters={[{ type: 'status', match: 'active' }]}
        />
        {meta && meta.touched && meta.error && (
          <span className="input-error">{meta.error}</span>
        )}
      </div>
    );
  }
}
